import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { authState } from '../recoil/authState';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * 토큰으로 로그인 유지된 경우, 서버에서 현재 사용자 정보(is_erp_booking_opened 등)를
 * 한 번 조회해 authState.user 및 localStorage 'me'를 동기화한다.
 */
export default function useAuthSync() {
  const auth = useRecoilValue(authState);
  const setAuth = useSetRecoilState(authState);
  const syncedRef = useRef(false);

  useEffect(() => {
    if (!auth?.isLoggedIn || !auth?.token || syncedRef.current) return;

    const token = auth.token || localStorage.getItem('auth-token');
    if (!token) return;

    syncedRef.current = true;
    axios
      .get(`${API_URL}/club/admin/me`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data;
        if (data?.success && data?.user) {
          setAuth((prev) => ({ ...prev, user: data.user }));
          try {
            localStorage.setItem('me', JSON.stringify(data.user));
          } catch (e) {
            // ignore
          }
        }
      })
      .catch(() => {
        syncedRef.current = false;
      });
  }, [auth?.isLoggedIn, auth?.token, setAuth]);
}
